
export default {
  name: 'TutorialGlossaryItem',

  props: {
    data: {
      type: Object,
      default: () => ({
        textImage: {},
      }),
    },
  },

  data() {
    return {
      title: this.data?.textImage?.Title,
      description: this.data?.textImage?.Description,
      imageObj: this.data?.textImage?.Image,
      mode: this.data?.textImage?.ImageFirst ? "image-text" : "text-image",
    }
  },
}
